'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const msg = [error?.message, error?.digest].filter(Boolean).join(' — ');
    console.error('Global application error', msg || error);
  }, [error]);

  return (
    <html lang="fr">
      <body className="min-h-screen antialiased">
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 py-16 text-center font-sans">
          <h1 className="text-lg font-semibold text-slate-900">HubUP — erreur</h1>
          <p className="text-sm text-slate-600 max-w-md">
            Une exception critique a interrompu l’affichage. Réessaie ou recharge la page.
          </p>
          {process.env.NODE_ENV === 'development' && error?.message ? (
            <p className="max-w-lg font-mono text-xs text-rose-700 break-words">{error.message}</p>
          ) : null}
          <button
            type="button"
            onClick={() => reset()}
            className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
          >
            Réessayer
          </button>
        </div>
      </body>
    </html>
  );
}
